import React from "react";
import { boardMembers } from "../data/content";

const HaberlerPage: React.FC = () => {
  const president = boardMembers[0];

  return (
    <div className="min-h-screen bg-bg-page pt-24">
      {/* Hero */}
      <div className="bg-gradient-to-br from-[#0F172A] to-[#1A2540] py-16 text-white">
        <div className="w-full px-6 xl:px-16 text-center">
          <div className="text-brand-gold text-sm font-semibold uppercase tracking-wider mb-2">
            Faaliyetler
          </div>
          <h1 className="text-3xl md:text-4xl font-bold mb-3">Haberler</h1>
          <p className="text-white/70 max-w-2xl mx-auto leading-relaxed">
            Derneğimizden ve şehrimizden son gelişmeler
          </p>
        </div>
      </div>

      <div className="w-full px-6 xl:px-16 py-16">

        {/* Haber: Bursaspor 1. Lig */}
        <article className="mb-16">
          {/* Haber başlığı */}
          <div className="mb-8">
            <div className="inline-flex items-center gap-2 bg-green-50 text-green-700 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
              <i className="fa-solid fa-trophy text-yellow-500" /> Kutlama
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-text-primary leading-snug">
              Bursaspor'umuz <span className="text-green-700">1. Lig'e Yükseldi!</span>
            </h2>
          </div>

          {/* Üst iki görsel */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
            {["/images/bursaspor-1.jpg", "/images/bursaspor-2.jpg"].map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`Bursaspor ${i + 1}`}
                className="w-full object-cover rounded-xl shadow-md"
                style={{ height: "320px" }}
              />
            ))}
          </div>

          {/* Metin sol + 3. görsel sağ */}
          <div className="flex flex-col md:flex-row gap-6 items-stretch">
            {/* Sol: metin */}
            <div className="flex-1 bg-white border border-border-light rounded-2xl p-8 shadow-sm flex flex-col justify-between">
              <div>
                <p className="text-text-muted leading-relaxed mb-4 text-justify">
                  Bursaspor'umuzun 1. Lig'e yükselmesini büyük bir memnuniyet ve gururla karşılıyoruz.
                </p>
                <p className="text-text-muted leading-relaxed mb-4 text-justify">
                  Yaşadığımız, emek verdiğimiz ve kendimizi ait hissettiğimiz güzel şehrimiz Bursa'nın en önemli değerlerinden biri olan Bursaspor'un bu anlamlı başarısı, hepimizi sevindirmiştir.
                </p>
                <p className="text-text-muted leading-relaxed mb-4 text-justify">
                  Bursaspor, sadece bir spor kulübü değil; Bursa'nın ortak hafızasını, mücadele ruhunu ve güçlü aidiyet duygusunu temsil eden köklü bir markadır. 1. Lig'e yükselmesi; inancın, emeğin, kararlılığın ve birlik ruhunun çok kıymetli bir sonucudur.
                </p>
                <p className="text-text-muted leading-relaxed mb-4 text-justify">
                  Bursa Trabzonlular Derneği olarak, şehrimizin sevinçlerini kendi sevincimiz, başarılarını da ortak gururumuz olarak görüyoruz. Bu vesileyle Bursaspor camiasını, kulüp yönetimini, teknik heyetini, futbolcularını ve büyük taraftarını yürekten tebrik ediyorum.
                </p>
                <p className="text-text-muted leading-relaxed text-justify">
                  Temennimiz, bu başarının Bursaspor'umuz için yeni ve daha güçlü bir dönemin başlangıcı olmasıdır. Kulübümüzün hak ettiği nice başarılara ulaşmasını diliyor, bu kıymetli sonucun Bursa'mıza hayırlı olmasını temenni ediyorum.
                </p>
              </div>
              {/* İmza */}
              <div className="flex items-center gap-3 pt-5 mt-5 border-t border-border-light">
                <img src="/baskan-foto.jpg" alt={president.name} className="w-11 h-11 rounded-full object-cover border-2 border-brand-bordo" />
                <div>
                  <div className="font-bold text-text-primary text-sm">{president.name}</div>
                  <div className="text-text-muted text-xs">Bursa Trabzonlular Derneği Başkanı</div>
                </div>
              </div>
            </div>

            {/* Sağ: 3. görsel */}
            <div className="w-full md:w-[420px] flex-shrink-0">
              <img
                src="/images/bursaspor-3.jpg"
                alt="Bursaspor kutlama"
                className="w-full h-full object-contain rounded-xl shadow-md bg-gray-50"
                style={{ minHeight: "300px" }}
              />
            </div>
          </div>
        </article>

      </div>
    </div>
  );
};

export default HaberlerPage;
